import  ActionType  from './ActionType';
import { IProgressItem } from '../components/mike-topbar-progress-spinner';

export interface DataAction {
  type:
    | ActionType.ADD_POLLING_ITEM
    | ActionType.RM_POLLING_ITEM
    | ActionType.UPDATE_POLLING_ITEM
    | ActionType.ADDUP_POLLING_ITEM;
  data: IProgressItem;
}

const addProgressItem = (state: IProgressItem[], action: DataAction) => {
  const _state = [action.data, ...state];
  // console.log('addProgressItem', _state);
  return _state;
};
const updateProgressItem = (state: IProgressItem[], action: DataAction, ix: number) => {
  state[ix] = action.data;
  // console.log('updateProgressItem', state, action, ix);
  return [...state];
};
// Check for matching item in state:
const getMatchIx = (state: IProgressItem[], item: IProgressItem) => {
  let ix = -1;
  state.forEach((entry, i) => {
    if (entry.id === item.id) ix = i;
  });
  return ix;
};

export const pollingItemsReducer = (state: IProgressItem[], action: DataAction) => {
  switch (action.type) {
    case ActionType.ADD_POLLING_ITEM:
      // First check that 'id' field is unique:
      if (state.find(item => item.id === action.data.id)) {
        console.warn(
          `ADD_POLLING_ITEM: List of pollingItems already has entry with id "${action.data.id}"`
        );
        return state;
      }
      // Go ahead if id is unique:
      return addProgressItem(state, action);

    case ActionType.RM_POLLING_ITEM:
    { 
      const rmState = state.filter(item => {
        return item.id !== action.data.id;
      });
      // console.log('ADD_POLLING_ITEM pollingItems', _state);
      return [...rmState]; }
    // return rmProgressItem(state, action);

    case ActionType.UPDATE_POLLING_ITEM:
      // Find index, warn if no mach:
    { 
      const ix = getMatchIx(state, action.data);
      if (ix < 0) {
        console.warn(`UPDATE_PROGRESS_ITEM: No match for ${action.data.id}`);
        return state;
      }
      // Go ahead if match:
      return updateProgressItem(state, action, ix); }

    // Add or update if exists, a combination
    // of ADD_POLLING_ITEM and UPDATE_POLLING_ITEM:
    case ActionType.ADDUP_POLLING_ITEM:
      // Check if there's a match:
    { 
      const jx = getMatchIx(state, action.data);
      if (jx > -1) {
        return updateProgressItem(state, action, jx);
      } else {
        return addProgressItem(state, action);
      } }

    default:
      return state;
  }
};
